import {
  FarmContainer
} from "./styled";
import { useContext, useState } from "react";
import {
  ContentCaontainer,
  ContentRight,
  LiquidityDetailsWrapper,
  TitleBox,
} from "../Liquidity/Details/styled";
import Stake from "./NewStake";
import ModalClaim from "./Finished/ModalClaim";
import Gift from "../../assets/gif/staking.gif";
import { ContextProviderWrapper, KeyvisualCommon, ModalOverlay } from "@kibble-exchange/uikit";
import close from "../../assets/Dashboard/Common/close.svg";
import useStakingLoad from "hooks/staking/useStakingLoad";

const Farm = () => {
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [dataModal, setDataModal] = useState<any>();
  const { isMobile, theme }: any = useContext(ContextProviderWrapper);
  useStakingLoad()
  
  return (
    <FarmContainer>
      <LiquidityDetailsWrapper className={theme}>
        {!isMobile && (
          <TitleBox style={{ marginTop: "-80px" }}>
            <h1 className="text-center h1">Staking</h1>
            <p className="text-center">High APR/APY rewards are waiting you.</p>
          </TitleBox>
        )}
        {isMobile && (
          <KeyvisualCommon
            title="KIB Staking"
            description={"Earn rewards by providing liquidity"}
            image={isMobile ? Gift : <></>}
            buttonText="Stake now"
            buttonLink="#"
            buttonIcon={""}
          />
        )}
        <ContentCaontainer>          
          <ContentRight>
            <Stake />           
          </ContentRight>
          {/* {isMobile && (
            <BlockCommingSoon className={theme}>
              <BlockCommingLeft>
                <img src={Comming} alt="" />
              </BlockCommingLeft>
              <BlockCommingRight>
                <BlockCommingTextBig className={theme}>
                  Waiting for our amazing staking feature.
                </BlockCommingTextBig>
                <BlockCommingTextSmall>Coming soon</BlockCommingTextSmall>
              </BlockCommingRight>
            </BlockCommingSoon>
          )} */}
          
        </ContentCaontainer>
      </LiquidityDetailsWrapper>
      <ModalOverlay
        component={<ModalClaim />}
        onClickParent={() => {
          setOpenConfirmModal(false);
        }}
        open={openConfirmModal}
        setOpen={setOpenConfirmModal}
        title={"claim rewards"}
        width="500px"
        closeIcon={close}
      />
    </FarmContainer>
  );
};

export default Farm;
